import { ChevronDown } from 'lucide-react'
import { ReactNode, useState } from 'react'

import { cn } from '@/utils'

const NavDropdownMobileMenu = ({
  children,
  content
}: {
  children: ReactNode
  content: ReactNode
}) => {
  const [open, setOpen] = useState(false)

  const toggleDropdown = () => {
    setOpen(!open)
  }

  return (
    <div className="relative">
      <button
        className="flex px-3 py-1"
        data-state={open ? `open` : `closed`}
        aria-expanded={open}
        onClick={toggleDropdown}
      >
        <span>{children}</span>
        <ChevronDown className={cn(`ml-1 w-4`, { 'rotate-180': open })} />
      </button>
      <div className="pl-3">
        {open && (
          <div
            data-state={open ? `open` : `closed`}
            className={cn(`mt-3 bg-zinc-800`, `min-w-[150px]`)}
          >
            <div
              data-motion={open ? `from-start` : `to-end`}
              className={cn(
                `data-[motion^=from-]:animate-in data-[motion^=to-]:animate-out data-[motion^=from-]:fade-in data-[motion^=to-]:fade-out`
              )}
            >
              {content}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default NavDropdownMobileMenu
